import { render, staticRenderFns } from "./ActivitiesApp.vue?vue&type=template&id=2df2cb76&scoped=true"
import script from "./ActivitiesApp.vue?vue&type=script&lang=js"
export * from "./ActivitiesApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df2cb76",
  null
  
)

export default component.exports